// extracted by mini-css-extract-plugin
module.exports = {"oam_logo":"oam-sider_oam_logo__2KI8d"};